export function onLoad(runable: () => void): void {
    const location = window.location.href
    document.addEventListener('astro:page-load', () => {
        if (location === window.location.href) {
            runable()
        }
    })
}

export function onAnalyticsReady(runable: () => void): void {
    /* @ts-ignore */
    if (!!window.r2) {
        runable()
    } else {
        onLoad(() => {
            /* @ts-ignore */
            if (!!window.r2) {
                runable()
            } else {
                document.addEventListener(
                    'r2-loaded',
                    () => {
                        runable()
                    },
                    { once: true }
                )
            }
        })
    }
}
